module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "product-main"
  }, [_c('group', {
    attrs: {
      "title": "产品基本信息",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "productName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "产品名称",
      "placeholder": "请输入产品名称",
      "text-align": "right",
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.productName),
      callback: function($$v) {
        _vm.$set(_vm.data, "productName", $$v)
      },
      expression: "data.productName"
    }
  }), _vm._v(" "), _c('my-selector', {
    ref: "orgType",
    attrs: {
      "title": "产品类型",
      "disabled": _vm.type === 0,
      "options": _vm.proTypeArry,
      "placeholder": "请选择产品类型"
    },
    model: {
      value: (_vm.data.productType),
      callback: function($$v) {
        _vm.$set(_vm.data, "productType", $$v)
      },
      expression: "data.productType"
    }
  }), _vm._v(" "), _c('datetime', {
    ref: "productFoundingDate",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "成立时间",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.type === 0 ? 'right' : '',
      "readonly": _vm.type === 0
    },
    model: {
      value: (_vm.data.productFoundingDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "productFoundingDate", $$v)
      },
      expression: "data.productFoundingDate"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "productSurvivalPeriod",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "存续期",
      "placeholder": "请输入存续期（年）",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.productSurvivalPeriod),
      callback: function($$v) {
        _vm.$set(_vm.data, "productSurvivalPeriod", $$v)
      },
      expression: "data.productSurvivalPeriod"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "productScale",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "产品规模",
      "type": "tel",
      "placeholder": "请输入产品规模（万元）",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.productScale),
      callback: function($$v) {
        _vm.$set(_vm.data, "productScale", $$v)
      },
      expression: "data.productScale"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "productManager",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "管理人",
      "placeholder": "请输入管理人",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.productManager),
      callback: function($$v) {
        _vm.$set(_vm.data, "productManager", $$v)
      },
      expression: "data.productManager"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "productDeposit",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "托管人",
      "placeholder": "请输入托管人,若无托管则填\"无\"",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.productDeposit),
      callback: function($$v) {
        _vm.$set(_vm.data, "productDeposit", $$v)
      },
      expression: "data.productDeposit"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "productRecordCode",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "备案机构",
      "placeholder": "请输入备案机构",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0
    },
    model: {
      value: (_vm.data.productRecordCode),
      callback: function($$v) {
        _vm.$set(_vm.data, "productRecordCode", $$v)
      },
      expression: "data.productRecordCode"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "productRecordNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "备案编号",
      "placeholder": "请填写编码中心分配的编码或协会备案产品编码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.productRecordNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "productRecordNo", $$v)
      },
      expression: "data.productRecordNo"
    }
  }), _vm._v(" "), _c('datetime', {
    ref: "productRecordDate",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "备案时间",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0
    },
    model: {
      value: (_vm.data.productRecordDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "productRecordDate", $$v)
      },
      expression: "data.productRecordDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    model: {
      value: (_vm.showCheckPopup),
      callback: function($$v) {
        _vm.showCheckPopup = $$v
      },
      expression: "showCheckPopup"
    }
  }, [_c('datetime-view', {
    attrs: {
      "end-date": _vm.todayDate
    },
    model: {
      value: (_vm.data.productFoundingDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "productFoundingDate", $$v)
      },
      expression: "data.productFoundingDate"
    }
  })], 1), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showPopup),
      callback: function($$v) {
        _vm.showPopup = $$v
      },
      expression: "showPopup"
    }
  }, [_c('datetime-view', {
    attrs: {
      "end-date": _vm.todayDate
    },
    model: {
      value: (_vm.data.productRecordDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "productRecordDate", $$v)
      },
      expression: "data.productRecordDate"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_product_next
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-367c2ebf"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorInfo/Product/One.vue
// module id = 1039
// module chunks = 1